export function isValueSelected(value: unknown, candidate: unknown) {
    if (candidate === undefined || value === undefined) {
        return false;
    }
    if (Array.isArray(value) && Array.isArray(candidate)) {
        return value.every((v) => candidate.includes(v));
    }
    if (Array.isArray(candidate)) {
        return candidate.indexOf(value) >= 0;
    }

    return value === candidate;
}
